import * as React from 'react'
import { Link, useHistory } from 'react-router-dom'
import axios from '../services/index'
import { UserIdContext, UserIsStaffContext, UsernameContext } from '../App'

//This component allow user to connect or to go to register and forgetpassword components
export const Connexion: React.FunctionComponent = (props) => {


    const [currentToken, setCurrentToken] = React.useState()
    const {currentUsername, setCurrentUsername} = React.useContext(UsernameContext)
    const {currentUserId, setCurrentUserId} = React.useContext(UserIdContext)
    const {currentUserIsStaff, setCurrentUserIsStaff} = React.useContext(UserIsStaffContext)
    let registerJSON = {}
    let history = useHistory()


    React.useEffect(() => {
            if(currentUserId) {
                axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/users/${currentUserId}/`, 
                {
                    headers: {
                        "Authorization": `Bearer ${currentToken}`
                    }
                })
                .then(function(response: any) {
                    setCurrentUserIsStaff(response.data.is_staff)
                    localStorage.setItem('userIsStaff', response.data.is_staff.toString())
                })
                .catch(function(error) {
                    alert("Une erreur est survenue ! Veuillez réessayer")
                    console.log(error)
                })
            }

    },[currentToken])

    const submitRegister= () => {
        axios.post('https://LaurenceBrun.eu.pythonanywhere.com/auth/login/', registerJSON,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )
        .then(function (response) {
            console.log(response)
            setCurrentUserId(response.data.user.pk)
            localStorage.setItem('userId', response.data.user.pk)
            setCurrentUsername(response.data.user.username)
            localStorage.setItem('username', response.data.user.username)
            setCurrentToken(response.data.access_token)
            localStorage.setItem('access_token', response.data.access_token)
            localStorage.setItem('refresh_token', response.data.refresh_token)
            history.push('/')
        })
        .catch(function(error) {
            console.log(error)
            return alert('Votre identifiant ou votre mot de passe est incorrect !')
        })
    }


    const handleSubmit = (event: any) => {
        event.preventDefault()
        if (event.target.username.value && event.target.password.value) {
                registerJSON = {
                    "username": event.target.username.value,
                    "password": event.target.password.value,
                }
                submitRegister()
        }
        else {
            alert('Vous devez remplir tous les champs !')
        } 
    }


    return(
        <div className="Connect">
            <h2>Connexion</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="text" name="username" placeholder="Nom d'utilisateur" />
                </label><br />
                <label>
                    <input type="password" name="password" placeholder="Mot de passe" />
                </label><br />
                <input type="submit" value="connexion" className="ConnectButton ConnexionBig" />
            </form>
           <Link to="/register"><div className="ConnectButton ConnexionSmall">Créer un compte utilisateur</div></Link>
           <Link to="/forgetPassword"><div className="ConnectButton ConnexionSmall">Vous avez oublié votre mot de passe ?</div></Link>
        </div>
    )
}